/* eslint-disable no-use-before-define */
/*
 *   Copyright (c) 2021 Busy Human LLC
 *   All rights reserved.
 *   This file, its contents, concepts, methods, behavior, and operation  (collectively the "Software") are protected by trade secret, patent,  and copyright laws. The use of the Software is governed by a license  agreement. Disclosure of the Software to third parties, in any form,  in whole or in part, is expressly prohibited except as authorized by the license agreement.
 */
// import { CollectionReference, DocumentSnapshot, DocumentReference, Query, QuerySnapshot } from "@firebase/firestore-types";
import { cloneDeep as _cloneDeep } from "lodash-es";
export function dataInstanceToData(instance) {
    const clone = _cloneDeep(instance);
    delete clone.$id;
    return clone;
}
export function DefaultFetchDataOptions() {
    return {
        clone: true,
        listen: false
    };
}
export function DefaultGetDataOptions() {
    return {
        clone: true
    };
}
export function DefaultDocumentUpdateOptions() {
    return {
        mergeDeep: false
    };
}
export function DefaultSubsetConstructorOptions() {
    return {
        listen: false
    };
}
//# sourceMappingURL=entity-interfaces.js.map